import { useMutation } from '@apollo/client';

import { MARK_STREAM_AS_NOT_RECURRING } from 'common/lib/graphQl/recurring';

const useMarkStreamAsNotRecurring = () => useMutation(MARK_STREAM_AS_NOT_RECURRING);

export default useMarkStreamAsNotRecurring;
